import React from 'react';
import { useNavigate } from 'react-router-dom';

export default function WelcomeModal({ username, spinTokens, onClose }) {
  const navigate = useNavigate();

  const handleSpin = () => {
    onClose();
    navigate('/spin');
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal" onClick={e => e.stopPropagation()} style={{ textAlign: 'center' }}>
        <div style={{ fontSize: 48, marginBottom: 8 }}>&#127807;</div>
        <h2 style={{ marginBottom: 8 }}>Welcome to the Greenhouse Club!</h2>
        <p style={{ color: 'var(--text-secondary)', marginBottom: 16 }}>
          What's good, <strong>{username}</strong>! You've been blessed with{' '}
          <span style={{ color: 'var(--warning)', fontWeight: 700 }}>{spinTokens} free spins</span>{' '}
          on the Leaf Wheel.
        </p>
        <div style={{
          background: 'var(--bg-secondary)', padding: 16, borderRadius: 'var(--radius-sm)',
          marginBottom: 20
        }}>
          <div style={{ fontSize: 32, fontWeight: 700, color: 'var(--success)' }}>
            {spinTokens} Spin Tokens
          </div>
          <div style={{ fontSize: 13, color: 'var(--text-muted)', marginTop: 4 }}>
            Win Bud Points, discounts & free rewards
          </div>
        </div>
        <div className="btn-row" style={{ justifyContent: 'center' }}>
          <button className="btn-primary" onClick={handleSpin} style={{ minWidth: 160 }}>
            Spin Now
          </button>
          <button className="btn-secondary" onClick={onClose}>
            Maybe Later
          </button>
        </div>
      </div>
    </div>
  );
}
